import { useState, useEffect } from "react";
import "../../assets/styles/Cricket.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Loader from "../../../../AsianExchangeSrc/utils/Loader";
import { GoDotFill } from "react-icons/go";
import { selectSite } from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";
import {
  updateGreyhoundMarket,
} from "../../../../AsianExchangeSrc/redux/slices/greyhoundSlice";
import { subscribeToGreyhoundMatchesData } from "../../../../socketClient";
import MobileMenu from "../../components/Mobilenav/MobileMenu";

const Greyhound = () => {
  const data = useSelector((state) => state?.greyhound?.greyhoundRaceList);

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("ALL");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const countryIcons = {
    GB: "/Flags/GB.svg",
    FRA: "/Flags/FRA.svg",
    FR: "/Flags/FRA.svg",
    USA: "/Flags/USA.svg",
    AU: "/Flags/AUS.svg",
    IRE: "/Flags/IRE.svg",
    IE: "/Flags/IRE.svg",
    RSA: "/Flags/RSA.svg",
    NZ: "/Flags/NZ.svg",
    IN: "/Flags/IN.svg",
    ZA: "/Flags/ZA.svg",
    HK: "/Flags/HK.svg",
    US: "/Flags/USA.svg",
  };

  // const fetch = async () => {
  //   try {
  //       if (!data) {
  //         setLoading(true)
  //       }
  //       const response = await grayhoundRace();
  //       // console.log("Greyhound", response.data);
  //       dispatch(updateGreyhoundSlice({ greyhoundRaceList: response?.data?.data?.t1 }))
  //       // setData(response?.data?.data?.t1);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  // };

  useEffect(() => {
    subscribeToGreyhoundMatchesData();
  }, []);

  // Unique country codes from data
  const availableTabs = data
    ? ["ALL", ...new Set(data?.map((e) => e?.cname))]
    : [];

  const handleDispatchGreyhoundOdds = (gmid, raceName, odds) => {
    dispatch(updateGreyhoundMarket({ gmid, odds }));

    // setTimeout(() => {
    //   navigate(`/Market?marketId=${gOdds?.marketId}&sportsName=greyhound&raceName=${raceName}`);
    // }, 200);
    setTimeout(() => {
      navigate(
        `/Market?gmid=${gmid}&sportsName=greyhound&raceName=${raceName}&sportId=${65}`
      );
    }, 200);
  };

  const topHeaderColor = useSelector(selectSite())?.headerColor;

  return (
    <>
       <div className="md:Middle-wraper md:w-[80%] w-[100%]">

        <div>
          <Box display="flex" flexDirection="column" sx={{ mb: 40 }}>
            <img
              src="/Banners/greyhoundracing-banner.jpg"
              alt="Greyhound Racing"
              className="hidden sm:block h-[80px] sm:h-auto"
            />

          <div className="pt-1.5">
              <MobileMenu />
          </div>

            {loading ? (
              <Loader />
            ) : (
              <div>
                <h4
                  className="text-[white] p-2 pl-2.5 text-[13px] font-bold"
                  style={{
                    backgroundImage: `linear-gradient(180deg, ${topHeaderColor?.start}, ${topHeaderColor?.end})`,
                  }}
                >
                  Greyhound Racing Schedule
                </h4>
                <div className="flex w-full border-b border-[#c8ced3] justify-between bg-[#e2e2e2] items-center">
                  <div className="w-full overflow-x-auto whitespace-nowrap">
                    <div className="flex w-max">
                      {availableTabs?.map((label, index) => (
                        <button
                          key={label}
                          onClick={() => setActiveTab(label)}
                          className={`font-bold text-[11px] flex flex-col items-center justify-center h-[45px] w-[70px] ${
                            activeTab === label
                              ? "bg-[white] text-black border-l border-[#c8ced3] border-r border-[#c8ced3]"
                              : "bg-[#e2e2e2] text-gray-600"
                          }`}
                        >
                          {countryIcons[label] ? (
                            <img
                              src={countryIcons[label]}
                              width={20}
                              alt={label}
                            />
                          ) : index === 0 ? (
                            "ALL"
                          ) : (
                            label
                          )}
                          <b>{countryIcons[label] && label}</b>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Filtered Data */}
                {data
                  ?.filter((e) => activeTab === "ALL" || e?.cname === activeTab)
                  ?.map((e, i) => {
                    // console.log("Hello", { e });
                    return (
                      <div className="mb-4" key={i}>
                        <div className="p-1 pl-2 font-bold text-[13.5px] text-[white] bg-gradient-to-r from-[#172832] via-[#1e3a4c] to-[#2c4d63] ">
                          {e?.cname}
                        </div>

                        {e?.children?.map((e, i) => {
                          let firstMatch = e?.children?.[0]?.stime;
                          firstMatch = firstMatch;
                          const matchDate = firstMatch
                            ? new Date(firstMatch).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                              })
                            : "";
                          const allMatchClosed = e?.childs?.every(
                            (match) => match?.hOdds?.status === "CLOSED"
                          );
                          if (allMatchClosed) {
                            return null;
                          }
                          const trackNameAndDate = `${e?.ename} ${matchDate}`;
                          return (
                            <div className="border-b p-2" key={i}>
                              <div className="font-bold text-[14px] font-[sans-serif]">
                                {trackNameAndDate}
                              </div>
                              <div className="flex flex-wrap gap-2 mt-2">
                                {e?.children?.map((match, index) => {
                                  const matchTime = new Date(match.stime);
                                  matchTime.setMinutes(
                                    matchTime.getMinutes() - 20
                                  );
                                  const currentTime = new Date();
                                  currentTime.setMinutes(
                                    currentTime.getMinutes() + 10
                                  );
                                  const currentlyAheadOfMatchTime =
                                    matchTime <= currentTime;
                                  const isActive =
                                    currentlyAheadOfMatchTime &&
                                    match?.hOdds?.status !== "CLOSED" &&
                                    match?.hOdds?.status !== "SUSPENDED";
                                  if (match?.hOdds?.status === "CLOSED") {
                                    return null;
                                  }
                                  const correctMatchTime = new Date(
                                    match.stime
                                  );
                                  const formattedTime =
                                    correctMatchTime.toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    });

                                  const showFormattedTime =
                                    correctMatchTime.toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    });

                                  const raceName =
                                    trackNameAndDate + " " + formattedTime;
                                  const now = new Date(); // Current time

                                  const timeDifferenceInMinutes = Math.floor(
                                    (correctMatchTime - now) / (1000 * 60)
                                  );
                                  return (
                                    <button
                                      // to={`/Market?marketId=${match?.eventId}`}
                                      onClick={() =>
                                        handleDispatchGreyhoundOdds(
                                          match?.gmid?.toString(),
                                          raceName,
                                          match.hOdds
                                        )
                                      }
                                      key={index}
                                      className={`px-1.5 flex items-center py-1.5 rounded text-[13px] ${
                                        isActive
                                          ? "bg-[#0c667e] text-[white]"
                                          : "bg-[#E8E8E8]"
                                      } border border-transparent hover:border-[0.5px] hover:border-[#27a6c3]`}
                                    >
                                      <span
                                        className={
                                          timeDifferenceInMinutes < 5 &&
                                          "inplay2"
                                        }
                                      >
                                        {" "}
                                        {formattedTime}{" "}
                                      </span>
                                      {
                                        <GoDotFill
                                          className={`ml-1 ${
                                            isActive && "inplay2"
                                          }`}
                                          color={
                                            match?.hOdds?.status === "SUSPENDED"
                                              ? "red"
                                              : "green"
                                          }
                                        />
                                      }
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
            )}
          </Box>
        </div>
      </div>
    </>
  );
};

export default Greyhound;
